import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShoppingBag1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconShoppingBag1"><Path fillRule="evenodd" clipRule="evenodd" d="M4.04403 3H19.9559L21.0468 21H2.95312L4.04403 3ZM9.74995 8V7.25H8.24995V8C8.24995 10.0711 9.92889 11.75 12 11.75C14.071 11.75 15.75 10.0711 15.75 8V7.25H14.25V8C14.25 9.24264 13.2426 10.25 12 10.25C10.7573 10.25 9.74995 9.24264 9.74995 8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShoppingBag1;
